module.exports = __webpack_public_path__ + "static/img/14000602.c4fd6f4e.png";